module.exports = __webpack_public_path__ + "img/智能识别.ac439a87.png";